<script setup lang="ts">
import { computed } from 'vue'
export interface Props {
  title?: string
  variant?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  variant: 'error'
})

const classes = computed(() => {
  return {
    error: 'text-red-500 bg-red-50 p-4 border-red-100',
    warning: ' text-yellow-500 bg-yellow-50 p-4 border-yellow-100',
    info: ' text-blue-500 bg-blue-50 p-4 border-blue-100',
    success: ' text-green-500 bg-green-50 p-4 border-green-100'
  }[props.variant]
})

const icon = computed(() => {
  return {
    error: 'tabler-circle-x-filled',
    warning: 'alert-circle-filled',
    info: 'info-circle-filled',
    success: 'circle-check-filled'
  }[props.variant]
})

</script>

<template>
  <div>
    <div
      class="flex rounded-md  border leading-snug text-base items-center py-2"
      :class="classes"
    >
      <storm-ui-icon
        :name="icon"
        class="mr-4 w-6 flex-shrink-0 h-6"
      />
      <div>
        <h4
          v-if="title"
          class="font-bold"
        >
          {{ title }}
        </h4>
        <div class="mt-1">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
